import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SEARCH_DECRYPTION_STORE_NAME, SearchDecryptionState } from './search-decryption.state';

/** Select SearchDecryption State */
export const selectSearchDecryptionState = createFeatureSelector<SearchDecryptionState>(SEARCH_DECRYPTION_STORE_NAME);

/** Select SearchDecryption isPending status */
export const selectSearchDecryptionIsPendingStatus = createSelector(
  selectSearchDecryptionState,
  (state) => !!state.isPending
);

/** Select SearchDecryption isFailure status */
export const selectSearchDecryptionIsFailureStatus = createSelector(
  selectSearchDecryptionState,
  (state) => !!state.isFailure
);
